import React from "react";
import { useNavigate, Link } from "react-router-dom";
// Corrected the import path for the CSS file from "../App.css" to "../styles.css"
// This assumes your main CSS file is named 'styles.css' as per our previous discussion.
import "../App.css";
import Logo from "../Rijschool.png";

const QuestionForm = () => {
  const navigate = useNavigate();

  const handleLoginButtonClick = () => {
    console.log("Reserveer een les button clicked");
    navigate("/Datepicker");
  };

  const handleAdminLoginButtonClick = () => {
    console.log("Instellingen button clicked");
    navigate("/appointments");
  };

  return (
    // Changed className from "homepage-container" to "main-content-wrapper"
    // to match the updated CSS for the main content area.
    <div className="main-content-wrapper fade-in-up">
      <button onClick={() => navigate('/')} className="form-home-button">Home</button>
      
      <h1 className="aharoni-style" style={{ fontSize: '3.5em', marginBottom: '40px' }}>PlanSucces</h1>
      
      <div className="admin-grid" style={{ maxWidth: '800px' }}>
        <div className="admin-card">
          <h3>Afspraken Bekijken</h3>
          <p>Bekijk een overzicht van alle geplande lessen per rijschool.</p>
          <button className="btn" onClick={handleAdminLoginButtonClick} style={{ width: '100%', minWidth: 'auto' }}>
            Ga naar overzicht
          </button>
        </div>

        <div className="admin-card">
          <h3>Les Reserveren</h3>
          <p>Plan direct je volgende rijles in bij jouw favoriete rijschool.</p>
          <button className="btn" onClick={handleLoginButtonClick} style={{ width: '100%', minWidth: 'auto' }}>
            Nu inplannen
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestionForm;
